import React, { useRef } from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './Advantages.scss';
import Games from './Games/Games';
import AdvantagesSlider from './Slider';
import { adobeTrack, getSeeAllGamesLink } from '../../utils';
import ViewAllGamesBtn from '../UI/Buttons/ViewAllGamesBtn';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { IProductsState } from '../../types/store/reducer';

interface IAdvantagesProps {
  loaded: boolean;
  freeTrialEligible: boolean;
  products: IProductsState;
  context?: IContent;
}

const Advantages = ({ products,context }: IAdvantagesProps) => {
  const gameSelectionSlider = useRef<HTMLDivElement>(null);
  const showcaseTitles = context.benefits.slider.filter(slide => slide.visible === "yes").map(slide => slide.trackingCode);

  return (
    <section className="advantages-wrapper">
      <h1
        id={'advantages_header'}
        className={'advantages_header'}
        dangerouslySetInnerHTML={{ __html: context.benefits_title }}
      />
      <AdvantagesSlider
        slideTitles={showcaseTitles}
        slides={context.benefits.slider}
      />
      <section className="advantages_ubisoft-plus">
        <div className="game-selection_outer">
          <h1>{context.benefits_games_title}</h1>
          <div
            className="ubisoft-plus_container game-selection_inner"
            ref={gameSelectionSlider}
          >
            <Games games={context.benefits_images} />
          </div>
        </div>
        <div className="ubisoft-plus_cta_wrapper">
          <ViewAllGamesBtn
            content={context.cta.see_games}
            redirect={getSeeAllGamesLink(products.countryCode)}
            handleClick={() =>
              adobeTrack('clickevent', context.tracking.view_all_games)
            }
          />
        </div>
      </section>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
  products: state.products
});
export default connect(mapStateToProps)(withContent(Advantages));
